import React from 'react';
import { subscribe } from 'react-contextual';
import { Container} from 'reactstrap';
import LocationBlock from './locationBlock';

const LocationPanel = props => (
	<Container className="gi-location-panel panel-padding">
		<LocationBlock className="gi-imagepanel" {...props} />
	</Container>
);

export default subscribe()(LocationPanel);
